import ContentNotification from './ContentNotification';

export default ContentNotification;
